import React, { useEffect, useLayoutEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { dialogLogin } from '../store/login/loginDialogReducer';
import { userService } from '../services/user.service';

const useTimer = () => {

    const { useSessionTime }  = userService.getUser();

    const [timer, setTimer] = useState(null);

    const dispatch = useDispatch();

    const { appInfo } = useSelector(store => store);

    const createTimer = () => {

        const currentTimer = new Date().getTime();

        const time = localStorage.getItem('currentTimer');

        
        if (time) {
            let resultMin = (currentTimer - time) / 60000;

            if (resultMin > appInfo.sessionTime) {

                dispatch(dialogLogin({ open: true }));
                userService.logoutOnlyToken();

            }

        } else {
            localStorage.getItem('currentTimer', currentTimer);
        }

    }

    const callApi = () => {

        setTimer(setInterval(createTimer, 2000));

    }

    useEffect(() => {

        if(useSessionTime){
            
            if (timer)
            clearInterval(timer);
            
            callApi();

        }
    }, [appInfo]);

    return {
        timer
    }
}

export default useTimer;
